import { useNotificationContext } from "../context/NotificationContext";

export default function useNotifications() {
  return useNotificationContext();
}
